import React from 'react';
import './ProjectChild.scss';

function ProjectChild({ title, image, source, preview }) {
  return (
    <div className="projectChild">
      <h3>{title}</h3>
      <img src={image} alt={title} />
      <div className="link-container">
        <a href={preview} target="_blank" rel="noreferrer">
          Preview
        </a>
        <a href={source} target="_blank" rel="noreferrer">
          Source Code
        </a>
      </div>
      <div className="outline"></div>
    </div>
  );
}

export default ProjectChild;
